import { addMonths } from "date-fns";

export const isExpireDateTwoMonth = (expireDate?: string) => {
  if (!expireDate) return false;

  const twoMonthLater = addMonths(new Date(), 2);
  twoMonthLater.setHours(0, 0, 0, 0);
  return twoMonthLater > new Date(expireDate);
};
